import styled from 'styled-components';

export const SnoflakeCanvas = styled.canvas`
  position: absolute;
  left: 0;
  top: 0;
  max-width: 100%;
  max-height: 100%;
  width: 100%;
  height: 100%;
  transition: opacity 1s ease;
`;
